<p-colorPicker
  [(ngModel)]="pickerValue"
  (ngModelChange)="onPickerValueChange($event)"
  [inline]="inline"
  [disabled]="disabled"
  [format]="format"></p-colorPicker>
